export const pixelsToRem = (pixels: string | number) => {
  return +pixels / 16
}

export const remToPixels = (rem: string) => {
  return +rem.replace('rem', '') * 16;
}